define([
    "underscore",
    "backbone"
], function(_, Backbone) {
    return Backbone.Model.extend({
        idAttribute: 'demo_member_cd',
        url: "/rest_open_account/demo_member",

        validation: {
            first_name: {
                required: true,
                pattern: 'alphaDashSpacesCommasDots'
            },
            last_name: {
                required: true,
                pattern: 'alphaDashSpacesCommasDots'
            },
            email: {
                required: true,
                pattern: 'email'
            },
            confirm_email:{
                required: true,
                equalTo: 'email'
            },
            phone_number: {
                required: true
            },
            country_abbr: {
                required: true
            },
            account_type: {
                required: true
            },
            currency_abbr: {
                required: true
            },
            leverage: {
                required: true
            },
            deposit: {
                required: true
            }
        }
    });
});



//////////////////
// WEBPACK FOOTER
// ./assets/common/main/js/models/demo_member_model.js
// module id = 26
// module chunks = 0